export default __webpack_public_path__ + "static/media/success-participate-icon.04f064e1.svg";